// extracted by mini-css-extract-plugin
module.exports = {"video_container":"FJVideo_video_container__1xPsP"};